import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { SharedService } from '../../_services/shared.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-offer-not-available',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './offer-not-available.component.html',
  styleUrl: './offer-not-available.component.css'
})
export class OfferNotAvailableComponent implements OnInit {

  @Input()
  _sharedService: SharedService | null = null;

  constructor(public sharedService: SharedService){

  }
  ngOnInit(): void {
    if(this._sharedService){
      console.log("OfferNotAvailableComponent: _sharedService is not null");
      this.sharedService = this._sharedService;
    }
  }


}
